var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"el-fade-in-linear"}},[_c('router-view',{class:_vm.$i18n.locale})],1),_c('AuthCompany',{ref:"authCompanyRef",on:{"comfirm":_vm.authCompanyHandle}}),_c('LoginDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }